import React, { useState } from "react";
import styles from "./ProductOverview.module.css";
import * as fa from "react-icons/fa";
import useContactStore from "../../../Stores/useContactStore";

import { useNavigate } from "react-router-dom";

function ProductOverview({ product }) {
  const [selectedOptions, setSelectedOptions] = useState({});

  const handleOptionChange = (optionIndex, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [optionIndex]: value,
    }));
  };

  const { contact, getContactDetails } = useContactStore();
  const [evaluateSelection, setEvaluateSelection] = useState(false);

  const buildOrderRequest = async () => {
    
    setEvaluateSelection(false);

    if (!product.Options || product.Options.length === 0) {
      return `Hello I'd like to order the following: ${product.Name}\n\nPlease could it be personalised with ...`;
    }

    if (Object.keys(selectedOptions).length === 0) {
      alert("Please select all options before ordering.");
      setEvaluateSelection(true);
      return;
    }

    if (product.Options.length > Object.keys(selectedOptions).length) {
      alert("Please select all options before ordering.");
      setEvaluateSelection(true);
      return;
    }

    let orderDetails = `Hello I'd like to order the following: ${product.Name}\n\n`;

    product.Options.forEach((option, index) => {
      orderDetails += `${option.OptionName}: ${selectedOptions[index]}\n`;
    });

    orderDetails += `\nPlease could it be personalised with ...`;

    return orderDetails;
  };

  const handleWhatsAppOrder = async () => {
    const orderDetails = await buildOrderRequest();
    if (!orderDetails) return;
    const result = await getContactDetails();

    if (!result) {
      alert("Failed to fetch contact details.");
      return;
    }
    const phoneNumber = result?.PhoneNumber || contact.PhoneNumber;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(orderDetails)}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleEmailOrder = async () => {
    const orderDetails = await buildOrderRequest();
    if (!orderDetails) return;

    const result = await getContactDetails();

    if (!result) {
      alert("Failed to fetch contact details.");
      return;
    }
    const emailAddress = result?.Email || contact.Email;

    const emailUrl = `mailto:${emailAddress}?subject=Order Request for ${product.Name}&body=${encodeURIComponent(orderDetails)}`;
    window.open(emailUrl, "_blank");
  };

  const navigate = useNavigate();

    const needsSelecting = (optionId) => {
    if (evaluateSelection) {
      console.log("Evaluating selection for optionId:", optionId, "Selected value:", selectedOptions[optionId]);
      // Logic to evaluate selection
      if (!selectedOptions[optionId]) {
        return true;
      }
    }
    return false;
  };


  return (
    <div className={styles.ProductOverview}>
      <div className={styles.ProductName}>{product.Name}</div>
      <div className={styles.ProductPrice}>£{product.Price}</div>
      <div className={styles.TrustTicks}>
        {product.TrustTicks && product.TrustTicks.length > 0
          ? product.TrustTicks.map((tic, index) => (
              <div key={index} className={styles.Tic}>
                <fa.FaCheck className={styles.TickIcon} />
                {tic.Description}
              </div>
            ))
          : null}
      </div>
      <div className={styles.ProductOptions}>
        {product.Options && product.Options.length > 0
          ? product.Options.map((option, index) => (
              <select
                key={index}
                className={`${styles.OptionSelect} ${needsSelecting(index) ? styles.NeedsSelecting : ""}`}
                value={selectedOptions[index] || ""}
                onChange={(e) => handleOptionChange(index, e.target.value)}
              >
                <option disabled={true} value="">
                  {option.DisplayName}
                </option>
                {option.OptionValues && option.OptionValues.length > 0
                  ? option.OptionValues.map((value, valIndex) => (
                      <option key={valIndex} value={value.Value}>
                        {value.Value}
                      </option>
                    ))
                  : null}
              </select>
            ))
          : null}
      </div>
      <div className={styles.OrderActions}>
        <button className={styles.OrderWhatsApp} onClick={handleWhatsAppOrder}>
          Order via WhatsApp
          <fa.FaWhatsapp className={styles.WhatsAppIcon} />
        </button>

        <button className={styles.OrderViaEmail} onClick={handleEmailOrder}>
          Order via Email
          <fa.FaEnvelope className={styles.EmailIcon} />
        </button>
        <button
          className={styles.EnquireToOrder}
          onClick={() => navigate("/Customer-Services/Contact")}
        >
          Enquire to Order
          <fa.FaPhone className={styles.PhoneIcon} />
        </button>
      </div>
    </div>
  );
}

export default ProductOverview;
